import {createSlice} from "@reduxjs/toolkit"
import { RootState } from "../DashboardStore"

interface MenuState {
    showCommandUsage: boolean,
    showAnalyticUsage: boolean,
    showLeaderboard: boolean
}

const initialState : MenuState = {
    showCommandUsage: true,
    showAnalyticUsage: false,
    showLeaderboard: false
}

export const MenuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers : {
        swapToCommandUsage : (state) => {
            state.showCommandUsage = true
            state.showAnalyticUsage = false
            state.showLeaderboard = false
        },
        swapToAnalyticUsage : (state) => {
            state.showAnalyticUsage = true
            state.showCommandUsage = false
            state.showLeaderboard = false
        },
        swapToLeaderboard : (state) => {
            state.showLeaderboard = true
            state.showAnalyticUsage = false
            state.showCommandUsage = false
        }

    }
})

export const {swapToCommandUsage,swapToAnalyticUsage,swapToLeaderboard} = MenuSlice.actions;
export const selectCommandUsage = (state:RootState) => state.menu.showCommandUsage;
export const selectAnalyticUsage = (state:RootState) => state.menu.showAnalyticUsage;
export const selectLeaderboard = (state:RootState) => state.menu.showLeaderboard;
export default MenuSlice.reducer;